import type { HttpError } from '~/shared/api'

import { UserQuery } from '../api'
import type { User } from '../types'

export type UseCurrentUserResult = {
  user: User | undefined
  isLoading: boolean
  error: HttpError | null
}

/** Тонкая обёртка над `UserQuery` — единая точка чтения текущего профиля во всём приложении. */
export function useCurrentUser(): UseCurrentUserResult {
  const { data, isLoading, error } = UserQuery.useQuery()

  return { user: data, isLoading, error }
}
